import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { StaticFileService } from '../static-file.service';
import { GoogleAnalyticsService } from '../google-analytics.service';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['../cart-page/cart-page.component.css', './about-page.component.css']
})
export class AboutPageComponent implements OnInit {
  public isClicked: boolean = false;
  public contactInfo = {
    'name': '',
    'email': '',
    'message': '',
    'subscribe': false,
    'botCatchSubject': ''
  }
  public confirmSent: boolean = false;
  public error: string;

  constructor(private restApi: RestApiService, 
              private staticFileService: StaticFileService,
              private gs: GoogleAnalyticsService) { }

  ngOnInit() {
  }

  public async onSubmit() {
    if(this.contactInfo.botCatchSubject !== '') {
      return;
    }
    this.isClicked = true;
    try {
      const res = await this.restApi.contact(this.contactInfo);
      if (res) {
        this.confirmSent = true;
      }
    } catch(err) {
      this.confirmSent = false;
      this.isClicked = false;
      console.error(err);
      this.error = 'There was a problem sending your message. Please make sure your email address ' + 
                   'is correct, or try again later.';
    }
  }

  public logCatcher() {
    this.gs.event('bot_attempt', 'bots', 'data-entry');
  }

  public toggleSubscribe() {
    this.contactInfo.subscribe = !this.contactInfo.subscribe;
  }

}
